<script>
    import SecretMenu from "./SecretMenu.svelte";
    import NormalMenu from "./NormalMenu.svelte";
    import axios from "axios";
    import {error} from "./stores";

    let cr = ""
    let nacl = "15"
    let ekg = 0
    let wbc = ""

    $: displaySecretMenu = cr === "30" && nacl === "30" && ekg === 30 && wbc === "30";

    export let video = ""
    export let onReset;

    let videoElement = {}

    $: {
        let g = document.getElementById("vid-div")
        if (g !== null) {
            // language=html
            g.innerHTML = `<video width="100%" autoPlay loop muted>
                <source src="` + video + `" type="video/webm">
                <source src="` + video + `" type="video/mp4">
            </video>`
        }
    }


    export let yeets = {
        "Single": {
            "cat": "https://files.catbox.moe/nmn0hn.webm",
            "cat2": "https://files.catbox.moe/higlar.webm",
        },
        "Replace Me": {
            "one": "https://s1.webmshare.com/LxKgL.webm",
            "two": "https://s1.webmshare.com/rVWre.webm",
            "three": "https://s1.webmshare.com/LxKgL.webm",
        },
        "Triplets": {
            "seven": "https://i.imgur.com/aPVsxAg.mp4",
            "eight": "https://i.imgur.com/qwO5SR4.mp4",
            "f": "https://i.imgur.com/hg5nLQi.mp4"
        }
    }

    function parseConfig(inp) {
        let tokens = inp.split("\n")
        let res = {}

        let categoryName = ""
        let videos = {}
        tokens.forEach((t, i) => {
            if (i === tokens.length - 1) if (categoryName !== "") res[categoryName] = videos
            if (t === "") return
            t = t.trim()
            if (t.substring(0, 1) === "=") {
                if (categoryName !== "") res[categoryName] = videos
                // clear
                videos = {}
                categoryName = t.substring(1, t.length).trim()
                return
            }
            let sp = t.split("=")
            let videoName = sp[0].trim()
            let videoLink = sp[1].trim()
            if (videoName === null || videoName === "" || videoName === undefined) return;
            videos[videoName] = videoLink
        })
        return res
    }

    axios.get(`./config.txt?ts=${Date.now()}`)
        .then(function (response) {
            // handle success
            console.log(response)
            console.log(response.data, typeof response.data)
            yeets = parseConfig(response.data)
        })
        .catch(function (e) {
            // handle error
            $error = e.stack
            $error = $error + (typeof e)
            console.log(e.stack, {e})
        })
        .then(function () {
            // always executed
        });

</script>

<div class="grid">
    <div class="sub m-left">
        {#if displaySecretMenu}
            <SecretMenu bind:video onReset={onReset} />
        {:else}
            <NormalMenu></NormalMenu>
        {/if}
    </div>
    <div class="m-mid" style="margin: 0 auto">
            {#if video === "none" || video === undefined}
                <h1 style="color:red; filter:drop-shadow(1px 1px 15px red);">NO SIGNAL DETECTED</h1>
            {/if}
            {#each Object.entries(yeets) as obj}
                {#each Object.entries(obj[1]) as thingy, i}
                    <video width={video === thingy[1] ? "100%" : "1px"}
                           data-current-video={video === thingy[1] ? "true" : "false"}
                           autoplay={video === thingy[1] ? "true" : null}
                           src={thingy[1]} loop muted crossorigin="anonymous" preload>
                        <source src={thingy[1] + '?' + new Date().getTime()} type="video/webm">
                        <source src={thingy[1] + '?' + new Date().getTime()} type="video/mp4">
                    </video>
                {/each}
            {/each}
    </div>
    <div class="bottom">
        <div>
            <span>Cr mmHG</span><input bind:value={cr} placeholder="70/80" class="mini" type="text">
        </div>
        <div>
            <span>NACL5 mmol/L</span>
            <select bind:value={nacl}>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="90">90</option>
            </select>
        </div>
        <div>
            <span>EKG-OD</span>
            <input type=number bind:value={ekg} min=0 max=30>
        </div>
        <div>
            <div>
                <span>WBC:RBC</span><input bind:value={wbc} class="mini" placeholder="5" type="text">
            </div>
        </div>
    </div>

</div>

<style>
    input[type=range] {
        width: 3rem;
    }

    .mini {
        padding: 2px;
        margin: 2px;
    }

    .bottom {
        display: grid;
        justify-items: center;
        align-items: baseline;
        align-self: end;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        height: 5em;
        width: 100%;
        bottom: 0;
        grid-column-start: 1;
        grid-column-end: 4;
        color: white;
        box-shadow: 0px 0px 20px midnightblue inset;
        background: linear-gradient(0deg, rgba(39, 32, 149, 1) 0%, rgba(36, 32, 142, 0.25) 60%, rgba(32, 32, 134, 0) 100%);
    }

    .bottom > div {
        border-right: 3px solid midnightblue;
        height: 100%;
        margin: auto;
        display: flex;
        width: 100%;
        justify-items: center;
        justify-content: center;
        align-items: center;
    }

    .bottom:last-child {
        border-right: none;
    }

    .grid {
        grid-template-rows: 1fr;
        grid-template-columns: 1fr 6fr;
        display: grid;
        height: 100%;
    }

    .border {
        border: 3px solid midnightblue;
    }

    .m-left {
        box-shadow: 0px 0px 20px midnightblue inset;
        background: linear-gradient(90deg, rgba(39, 32, 149, 1) 0%, rgba(36, 32, 142, 0.25) 60%, rgba(32, 32, 134, 0) 100%);
    }

    .m-right {
        box-shadow: 0px 0px 20px midnightblue inset;
        background: linear-gradient(-90deg, rgba(39, 32, 149, 1) 0%, rgba(36, 32, 142, 0.25) 60%, rgba(32, 32, 134, 0) 100%);
    }

    .m-right, .m-left {
        padding: 1rem;
    }

    select {
        margin: 0;
    }
</style>
